import { cn } from "@/utils";
import React from "react";
import ClientsLogos from "./clients-logos";

interface ClientsSliderProps extends React.HTMLProps<HTMLDivElement> {}

const ClientsSlider: React.FC<ClientsSliderProps> = ({ className, ...props }) => {
  return (
    <div className={cn("flex gap-20 overflow-x-hidden", className)} {...props}>
      <div className="relative flex">
        <ClientsLogos className="animate-marquee" />
        <ClientsLogos className="absolute top-0 animate-marquee2" />
      </div>
    </div>
  );
};

export default ClientsSlider;
